import {create} from 'zustand'
import {acionsTypesReqesut, Action, Dispatch} from '../../logic/actionsType'
import {ICheque, IFacilitiesItems, IFile, IRequest} from '../../../interfaces'

type TReqesutState = {
  currentStep?: number
  requestList?: IRequest[]
  backCheques?: ICheque[]
  requestValues?: IRequest | undefined
  requestFiles?: IFile[]
  listOfFacilities?: IFacilitiesItems[]
}

type State = {
  state: TReqesutState
}

const reducer = (
  state: State,
  action: Action<keyof typeof acionsTypesReqesut, TReqesutState>
): State => {
  switch (action.type) {
    case 'SET_CURRENT_STEP':
      return {state: {...state.state, currentStep: action.payload.currentStep}}
    case 'SET_REQUEST_DATA':
      return {state: {...state.state, requestValues: action.payload.requestValues}}
    case 'SET_REQUEST_FILE_DATA':
      return {state: {...state.state, requestFiles: action.payload.requestFiles}}
    case 'SET_REQUEST_LIST':
      return {state: {...state.state, requestList: action.payload.requestList}}
    case 'SET_CHEQUE_LIST':
      return {state: {...state.state, backCheques: action.payload.backCheques}}
    case 'SET_FACILITIES_LIST':
      return {state: {...state.state, listOfFacilities: action.payload.listOfFacilities}}
    default:
      return state
  }
}

export const useRequestStore = create<
  State & Dispatch<keyof typeof acionsTypesReqesut, TReqesutState>
>((set) => ({
  state: {
    currentStep: 0,
    requestValues: undefined,
    requestFiles: undefined,
    requestList: undefined,
    backCheques: undefined,
    listOfFacilities: undefined,
  },
  dispatch: (action) => {
    set((state: State) => reducer(state, action))
  },
}))
